export default "__VITE_ASSET__D6IB6p_K__"